import Alpine from "alpinejs"

// Create a shared store for filter state
Alpine.store("filterState", {
    activeType: "reset",
})

Alpine.data("searchFilter", (inputType, variant = "horizontal", dynamic = false) => ({
    inputType: inputType,
    variant: variant,
    selected: ["reset"],
    disabled: false,
    items: null,
    init() {

        this.resetFilter()
        // Listen for reset events from parent component
        this.$el.addEventListener("searchFilter:reset", () => {
            this.resetFilter()
        })

        // Listen for update events to sync filters
        this.$el.addEventListener("searchFilter:update", (event) => {
            if (event.detail && event.detail.identifier) {
                this.updateSelection(event.detail.identifier)
            }
        })

        // After all initialization is done, ensure the reset option is always selected
        Alpine.store("filterState").activeType = "reset"

        // For dynamic content, watch result changes
        if (dynamic) {
            // From parent component
            this.$watch("result", (value) => {
                this.items = value.aggregations
            })
        }
    },
    resetFilter() {
        // Reset the selection state
        this.selected = ["reset"]

        // Update the Alpine store
        Alpine.store("filterState").activeType = "reset"

        // Use querySelectorAll to find all reset inputs (both static and dynamic templates)
        const resetInputs = this.$el.querySelectorAll('input[value="reset"], input[id="reset"]')
        resetInputs.forEach((input) => {
            input.checked = true
        })

        const otherInputs = this.$el.querySelectorAll('input:not([value="reset"]):not([id="reset"])')
        otherInputs.forEach((input) => {
            input.checked = false
        })
    },
    updateSelection(identifier) {
        // Update the internal selected array
        this.selected = [identifier]

        // Manually update input checked states to match
        const allInputs = this.$el.querySelectorAll("input")
        allInputs.forEach((input) => {
            input.checked = input.value === identifier
        })
    },
    toggleSelection(identifier) {
        if (this.disabled) return

        const id = String(identifier)
        console.log("Toggle Selection:", { id, type: typeof id })

        if (id === "reset") {
            this.selected = ["reset"]

            // Update shared store
            Alpine.store("filterState").activeType = "reset"

            // Notify all search filters to update selection
            document.querySelectorAll(".c-searchFilter").forEach((filter) => {
                if (filter !== this.$el) {
                    filter.dispatchEvent(
                        new CustomEvent("searchFilter:update", {
                            bubbles: false,
                            detail: { identifier: "reset" },
                        }),
                    )
                }
            })

            const event = new CustomEvent("searchFilter:clear-items", {
                bubbles: true,
                detail: { id: "filter" },
            })
            this.$el.dispatchEvent(event)
            return
        }

        if (this.inputType === "radio") {
            if (id !== this.selected[0]) {
                this.selected = [id]

                // Update shared store
                Alpine.store("filterState").activeType = id

                // Notify all search filters to update selection
                document.querySelectorAll(".c-searchFilter").forEach((filter) => {
                    if (filter !== this.$el) {
                        filter.dispatchEvent(
                            new CustomEvent("searchFilter:update", {
                                bubbles: false,
                                detail: { identifier: id },
                            }),
                        )
                    }
                })

                const label = this.$el.querySelector(`label[for="${id}"]`)
                const title = label?.querySelector(".c-searchFilter__label--title")?.textContent || ""

                const event = new CustomEvent("searchFilter:add-item", {
                    bubbles: true,
                    detail: {
                        id: "filter",
                        identifier: id,
                        title: title,
                    },
                })
                this.$el.dispatchEvent(event)
            } else {
                // User clicked on already selected filter - reset to "All"
                this.selected = ["reset"]

                // Update shared store
                Alpine.store("filterState").activeType = "reset"

                // Notify all search filters to update selection
                document.querySelectorAll(".c-searchFilter").forEach((filter) => {
                    filter.dispatchEvent(
                        new CustomEvent("searchFilter:update", {
                            bubbles: false,
                            detail: { identifier: "reset" },
                        }),
                    )
                })

                // Dispatch clear items event to parent components
                const event = new CustomEvent("searchFilter:clear-items", {
                    bubbles: true,
                    detail: { id: "filter" },
                })
                this.$el.dispatchEvent(event)
            }
        }
    },
}))
